<template>
  <div class="min-h-screen bg-gray-50">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "MainView",
};
</script>
